export const ID = '527c8dcb-f2b9-4397-87fa-17aecacf416a';

export const NAME = 'Facility Reviews';
